import clsx from "clsx";

import HeadingTag from "@components/HeadingTag";
import DotBorder from "@components/DotBorder";

const Heading = ({ children, size, alignment = "center", className = "" }) => {
	return (
		<div
			className={clsx(
				"Heading font-medium",
				`Heading--${size}`,
				{
					"text-3xl lg:text-4xl 3xl:text-5xl": size === "h1",
					"text-3xl lg:text-4xl lg:leading-15": size === "h2",
					"text-2xl": size === "h3",
					"text-xl": size === "h4",
				},
				className
			)}
		>
			<HeadingTag tag={size}>{children}</HeadingTag>
		</div>
	);
};

export default Heading;
